import React, { Fragment, useEffect, useState } from "react";
import {
    Header, Segment, Button, Icon, Form, Checkbox, Modal
} from 'semantic-ui-react';
import ImageUploading from "react-images-uploading";
import Loader from "../../sharedComponent/loader/loader";

import * as utility from '../../../services/utility';
import { Constants } from '../../../config/appConstants';
import SelectTaskCode from '../../sharedComponent/selectTaskCode/selectTaskCode.Container';
import AttachmentViewer from '../../sharedComponent/attachmentViewer/attachmentViewer.Container';
import ConfirmationPopup from "../TMVoucher/TMVoucherComponents/ConfirmationPopup";

const TimeCardDetailsEditComponent = (props) => {
    let [isProjectDropdownOpen, setProjectDropdownOpen] = useState(false);
    useEffect(() => {
        let projectDropdown = document.querySelector('.ui.active.visible.dropdown .visible.menu');
        if (isProjectDropdownOpen && projectDropdown) {
            projectDropdown.scrollTop = 0;
        }
    }, [isProjectDropdownOpen]);

    return (
        <Fragment>
            {props.timecard.isShowSelectTaskCode ?
                <Segment.Group>
                    <SelectTaskCode
                        selectedTaskNumber={props.timecard.selectedTaskNumber}
                        selectedTaskName={props.timecard.selectedTaskName}
                        selectedProjectID={props.timecard.selectedProjectID}
                        selectedProjectNumber={props.timecard.selectedProjectNumber}
                        onHandleTaskCodeSelection={props.onHandleSelectTaskCodePageSelection}
                        onHandleBackButton={props.onHandleSelectTaskCodePageBackButton}
                    />
                </Segment.Group>
                :
                <Segment.Group>
                    <Segment className="stickyHeader zIndex-14">
                        <Header as="h3" size='medium' textAlign='center'> Edit Timecard Details </Header>
                        <Header as="h2" size='tiny' className='d-flex align-items timeCardDetails'>
                            {props.timecard.employeeName &&
                                <Fragment>
                                    <p className='w-50 m-0 textOverflow overflowHidden whiteSpace'> {props.timecard.employeeName} ({props.timecard.employeeNumber})</p>
                                    <p className='w-50 m-0 text-right'>{`Date: ${utility.getMMDDYYYYDateTime(props.timecard.selectedDate)}`}</p>
                                </Fragment>}
                        </Header>
                    </Segment>
                    <Segment className="overflowScroll pb-3" style={{ height: 'calc(100vh - 126px)' }}>
                        {props.timecard.timecards && props.timecard.timecards.length > 0 && props.timecard.timecards.map((rowData, index) => (
                            !rowData.isDeleted &&
                            <div className="duplicateHighlighted" style={{ border: rowData.isDupicate ? '5px solid red' : '1px solid white' }}>
                                <Form className="flexDirectionColumnReverse d-flex" key={index}>
                                    <div className='padding'>
                                        {(props.timecard.timecards.length - 1) !== index && <Button type="button" compact negative size='small' className='mb-2' onClick={(e) => { props.onClickDeleteButton(index) }}>
                                            <Icon name='trash' /> Delete Line </Button>}
                                        <Form.Group >
                                            <div className='d-flex flexDirectionRow'>
                                                <div className='d-flex align-items flexDirectionColumn groupForm'>
                                                    <Form.Group className='pb-1'>
                                                        <Form.Select style={{ width: '240px' }} options={props.timecard.projectOptions}
                                                            fluid
                                                            className="editTimecardField"
                                                            label='Project'
                                                            placeholder='Select Project'
                                                            onChange={(e, { value }) => { props.handleInputChange(value, index, Constants.PROJECT_DROPDOWN) }}
                                                            value={rowData.projectID > 0 ? rowData.projectID : ''}
                                                            selectOnBlur={false}
                                                            text={rowData.projectID > 0 ? "" : "Select Project"}
                                                            onClose={() => setProjectDropdownOpen(false)}
                                                            onOpen={() => setProjectDropdownOpen(true)}
                                                        />

                                                        <Form.Select className="hideDefaultText" style={{ width: '240px' }} options={props.timecard.shiftOptions}
                                                            fluid
                                                            label='Shift'
                                                            placeholder=' '
                                                            onChange={(e, { value }) => { props.handleInputChange(value, index, Constants.SHIFT_DROPDOWN) }}
                                                            value={rowData.shift ? `${rowData.shift.toString()}` : ""}
                                                            selectOnBlur={false}
                                                            disabled={props.timecard.isTimeCardAttested}
                                                        />
                                                        <Form.Input style={{ width: '60px' }}
                                                            fluid
                                                            label='ST Hours'
                                                            placeholder=''
                                                            maxLength={10}
                                                            onChange={(e) => { props.handleInputChange(e, index, Constants.ST_HOURS) }}
                                                            value={rowData.stHours}
                                                            disabled={props.timecard.isTimeCardAttested}
                                                        />
                                                        <Form.Input style={{ width: '240px' }}
                                                            fluid
                                                            label='Actual Units'
                                                            placeholder='Units'
                                                            maxLength="5"
                                                            onChange={(e) => { props.handleInputChange(e, index, Constants.ACTUAL_UNITS) }}
                                                            value={rowData.workUnits}
                                                        />
                                                        <Form.Input style={{ width: '240px' }}
                                                            fluid
                                                            label='Expectations Units'
                                                            placeholder='Units'
                                                            maxLength="5"
                                                            onChange={(e) => { props.handleInputChange(e, index, Constants.EXPECTATIONAL_UNITS) }}
                                                            value={rowData.expectationUnits} />

                                                    </Form.Group>
                                                    <Form.Group className='fieldSetup'>
                                                        <div className='d-flex align-items flexDirectionColumn justify-content-between groupForm'>
                                                            <Form.Group>
                                                                <Form.Input style={{ width: '240px' }}
                                                                    fluid
                                                                    label='Task Code'
                                                                    placeholder=''
                                                                    value={rowData.taskName ? `${rowData.taskNumber} - ${rowData.taskName}` : ""}
                                                                    onFocus={() => props.onShowSelectTaskCodePage(index)} />
                                                                <Form.Field style={{ width: '260px' }} className='checkBoxEditCard'>
                                                                    <label>Work done at job site</label>
                                                                    <Checkbox style={{ width: '38px', height: '38px' }}
                                                                        checked={rowData.workDoneAtJobSite === "Yes"}
                                                                        onChange={() => { props.handleInputChange(rowData.workDoneAtJobSite, index, Constants.WORKDONE_CHECKBOX) }} />
                                                                </Form.Field>
                                                                <Form.Input style={{ width: '60px' }}
                                                                    fluid
                                                                    label='OT Hours'
                                                                    placeholder=''
                                                                    maxLength={10}
                                                                    onChange={(e) => { props.handleInputChange(e, index, Constants.OT_HOURS) }}
                                                                    value={rowData.otHours}
                                                                    disabled={props.timecard.isTimeCardAttested}
                                                                />
                                                            </Form.Group>
                                                            <Form.Group className="fieldSetup">
                                                                <Form.Input style={{ width: '240px' }}
                                                                    fluid
                                                                    label='Job Override'
                                                                    placeholder='Job Override'
                                                                    maxLength={10}
                                                                    onChange={(e) => { props.handleInputChange(e, index, Constants.JOB_OVERRIDE) }}
                                                                    value={rowData.jobOverride ? rowData.jobOverride.toString() : ""} />
                                                                <Form.Input style={{ width: '240px' }}
                                                                    fluid
                                                                    label='Union Override'
                                                                    placeholder='Union Override'
                                                                    maxLength={10}
                                                                    onChange={(e) => { props.handleInputChange(e, index, Constants.UNION_OVERRIDE) }}
                                                                    value={rowData.unionOverride ? rowData.unionOverride.toString() : ""} />
                                                                <Form.Input style={{ width: '60px' }}
                                                                    fluid
                                                                    label='DT Hours'
                                                                    maxLength={10}
                                                                    placeholder=''
                                                                    onChange={(e) => { props.handleInputChange(e, index, Constants.DT_HOURS) }}
                                                                    value={rowData.dtHours}
                                                                    disabled={props.timecard.isTimeCardAttested}
                                                                />
                                                            </Form.Group>
                                                        </div>
                                                        <Form.TextArea className="editNotes"
                                                            label='Actual Work Notes'
                                                            placeholder='Actual Notes'
                                                            maxLength={1000}
                                                            onChange={(e) => { props.handleInputChange(e, index, Constants.ACTUAL_NOTES) }}
                                                            value={rowData.workNote ? rowData.workNote.toString() : ""} />
                                                        <Form.TextArea className="editNotes"
                                                            label='Expectations Notes'
                                                            placeholder='Notes'
                                                            maxLength={1000}
                                                            onChange={(e) => { props.handleInputChange(e, index, Constants.EXPECTATIONAL_NOTES) }}
                                                            value={rowData.expectationNote ? rowData.expectationNote.toString() : ""} />
                                                    </Form.Group>
                                                </div>
                                                <div className='d-flex align-items-start flexDirectionColumn groupForm justify-content-between'>
                                                    <Form.Field>
                                                        <label>Actual Notes Attachments</label>
                                                        <div className='d-flex justify-content-between'>
                                                            <ImageUploading
                                                                multiple
                                                                value={rowData.attachments}
                                                                onChange={(e) => { props.onAddActulNoteAttachment(index, e) }}
                                                                acceptType={['jpg', 'png']}
                                                            >{({
                                                                onImageUpload,
                                                                isDragging,
                                                                dragProps,
                                                            }) => (
                                                                <div className="upload__image-wrapper">
                                                                    <Button type="button" secondary className="borderRadius w-100" size='small' style={isDragging ? { color: 'red' } : undefined} onClick={onImageUpload}
                                                                        {...dragProps}>
                                                                        Select files...  </Button>
                                                                    <div className="attachmentImage" style={{ width: '245px' }}>
                                                                        {rowData.attachments && rowData.attachments.map((image, attachmentindex) => (
                                                                            image.isActive ?
                                                                                <div key={attachmentindex} >
                                                                                    <img src={Constants.DATA_BASE64 + image.attachmentContent} className='modalSubImage pointer' alt="" onClick={() => props.onClickViewActaulNoteAttachment(image)} />
                                                                                    <div className="image-item__btn-wrapper attachmentPointer">
                                                                                        <Icon name="close" onClick={() => props.onRemoveActualNoteAttachment(index, attachmentindex)}></Icon>
                                                                                    </div>
                                                                                </div> : ''
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}
                                                            </ImageUploading>
                                                        </div>
                                                    </Form.Field>
                                                    <Form.Field>
                                                        <Form.Select style={{ width: '245px' }} options={props.timecard.statusCodeDataList}
                                                            fluid
                                                            label="Status Code"
                                                            labelField="fieldStatusInitialAndDescription"
                                                            placeholder='-Select-'
                                                            valueField='fieldStatusId'
                                                            onChange={(e, { value }) => { props.handleInputChange(value, index, Constants.STATUSCODE_DROPDOWN) }}
                                                            value={rowData.fieldStatusId}
                                                            key={rowData.fieldStatusId}
                                                            selectOnBlur={false}
                                                        />
                                                    </Form.Field>
                                                </div>
                                            </div>
                                        </Form.Group>
                                    </div>
                                </Form>
                            </div>
                        ))
                        }
                    </Segment>

                    <Segment>
                        <div className='d-flex align-items justify-content-between btnFooter'>
                            <Button type="button" secondary className="borderRadius w-10" size='small' onClick={props.onClickBackButton}>Back</Button>
                            <Button  type="button" secondary className="borderRadius w-20" size='small' onClick={props.onClickAddNewLineButton}>Add New Line</Button>
                            <Button disabled={props.timecard.isSaveButtonDisabled} type="button" secondary className="borderRadius w-10" size='small' onClick={props.onClickSaveButton}>Save</Button>
                        </div>
                    </Segment>

                </Segment.Group>
            }

            {/* Attachment Viewer popup */}
            {
                props.timecard.isViewAttachmentModelVisible &&
                <AttachmentViewer
                    attachmentName={props.timecard.selectedAttachment.attachmentName}
                    attachmentContent={props.timecard.selectedAttachment.attachmentContent}
                    closeAttachmentViewer={props.onCloseViewAttachment} />
            }

            {/* Save Confirmation popup */}
            <Modal
                open={props.timecard.isShowTimecardsSaveConfirmation}
                closeOnDimmerClick={false}
                size='tiny'
            >
                <Modal.Header className="text-center">Confirmation</Modal.Header>
                <Modal.Content >
                    Do you want to save changes?
                </Modal.Content>
                <Modal.Actions className="d-flex justify-content-between">
                    <Button type="button" secondary className="borderRadius w-25 ml-0" size='small' onClick={props.onCloseShowTimecardsSaveConfirmation}>
                        No
                    </Button>
                    <Button type="button" secondary className="borderRadius w-25 mr-0" size='small' onClick={props.onClickSaveButton}>
                        Yes
                    </Button>
                </Modal.Actions>
                {props.timecard.isShowLoader &&
                    <Loader />
                }
            </Modal>

            {props.timecard.isShowAttestationErrorModal &&
                <ConfirmationPopup
                    isShowConfirmation={props.timecard.isShowAttestationErrorModal}
                    confirmationHeader={Constants.WARNING_HEADER_MESSAGE}
                    confirmationMessage={props.timecard.attestErrorValidationMessage}
                    noText={Constants.BUTTON_BACK}
                    isShowYes={false}
                    onClickCloseBtn={() => props.closeAlreadyAttestedPopup()}
                />
            }

            {/* loader */}
            {props.timecard.isShowLoader &&
                <Loader />
            }
        </Fragment>
    );
}

export default TimeCardDetailsEditComponent;

TimeCardDetailsEditComponent.displayName = "TimeCardDetailsEditComponent";